import React, { useMemo } from 'react';
import { HbrCard } from '@harbor/elements-react-standalone';

type Props = {
  items?: any[];
  completionByItemId?: Record<string | number, boolean>;
  pendingValidationByItemId?: Record<string | number, boolean>;
  notApplicableByItemId?: Record<string | number, boolean>;
};

const isTrackableJourneyItem = (item: any) => {
  if (!item) return false;
  if (item?.item_type === 'section') return false;
  return true;
};

const JourneyMapProgress: React.FC<Props> = ({
                                               items = [],
                                               completionByItemId = {},
                                               pendingValidationByItemId = {},
                                               notApplicableByItemId = {},
                                             }) => {
  const { totalCount, completedCount, pendingCount, percent, isComplete } = useMemo(() => {
    const trackableApplicableItems = items.filter((item) => {
      if (!isTrackableJourneyItem(item)) return false;
      const itemId = String(item.id);
      return !notApplicableByItemId[itemId];
    });

    const total = trackableApplicableItems.length;
    const completed = trackableApplicableItems.filter(
      (item) => completionByItemId[String(item.id)]
    ).length;

    const pending = trackableApplicableItems.filter(
      (item) =>
        !completionByItemId[String(item.id)] &&
        !!pendingValidationByItemId[String(item.id)]
    ).length;

    const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
    const complete = total > 0 && completed >= total;

    return {
      totalCount: total,
      completedCount: completed,
      pendingCount: pending,
      percent: pct,
      isComplete: complete,
    };
  }, [items, completionByItemId, pendingValidationByItemId, notApplicableByItemId]);

  return (
    <div className="hbr-css__layout-col-sm">
      <HbrCard
        style={
          {
            '--box-shadow': 'none',
            '--border-width': '2px',
            '--border-radius': '8px',
            '--border-color': 'var(--hbr-color-neutral-border-weak)',
          } as React.CSSProperties
        }
      >
        <div slot="header" className="hbr-css__layout-row-sm hbr-css__layout-justify-between">
          <div className="hbr-css__text-heading-sm-bold">Journey Progress</div>
          <div className="hbr-css__text-secondary-sm">
            {completedCount} / {totalCount} complete
          </div>
        </div>

        <div className="hbr-css__layout-col-xs">
          <div
            style={{
              width: '100%',
              height: '12px',
              borderRadius: '999px',
              backgroundColor: 'var(--hbr-color-neutral-bg-weak)',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <div
              style={{
                width: `${percent}%`,
                height: '100%',
                borderRadius: '999px',
                backgroundColor: isComplete
                  ? 'var(--hbr-color-success)'
                  : 'var(--hbr-color-info)',
                transition: 'width 250ms ease',
                minWidth: percent > 0 ? '8px' : '0px',
              }}
            />
          </div>

          <div className="hbr-css__text-secondary-xs">
            {percent}% completed
            {pendingCount > 0 ? ` • ${pendingCount} pending validation` : ''}
          </div>
        </div>
      </HbrCard>
    </div>
  );
};

export default JourneyMapProgress;